import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeExamples = data => {
  const example = new schema.Entity('examples')
  return normalize(data, [example])
}

const ExamplesReducer = combineReducers({
  fetchExamplesRequest: createRequestReducer('EXAMPLES:FETCH'),
  filters: createReducer(
    { schoolOrganisation: false },
    {
      'EXAMPLES:FILTER_SCHOOL_ORGANISATION': state => ({
        ...state,
        schoolOrganisation: true
      }),
      'EXAMPLES:FILTER_ALL': state => ({
        ...state,
        schoolOrganisation: false
      })
    }
  ),
  examples: createReducer(null, {
    'EXAMPLES:FETCH_REQUEST_SUCCESS': (state, { response }) => {
      return normalizeExamples(response.data.assessment_files)
    }
  })
})

export default ExamplesReducer
